import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Paper from "@material-ui/core/Paper";
import { Header } from "../../shared";
import { useHistory } from "react-router-dom";
import { Box } from "@material-ui/core";
import { CommonCss } from "../../services/CommonCss";

const useStyles = makeStyles((theme) => ({
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  selectedClass: {
    "&:hover": {
      color: "#FF4717",
    },
    width: "120px",
    background: "#FF4717",
    border: "2px solid #FF4717",
    borderRadius: "6px",
    color: "#FFF",
  },
  unSelected: {
    width: "120px",
    border: "2px solid #FF4717",
    borderRadius: "6px",
    color: "#FF4717",
  },
}));

export default function RequestMail(props) {
  const { email } = props.location;

  const { innerWidth: width, innerHeight: height } = window;
  const classes = useStyles();
  const commonClasses = CommonCss();
  const history = useHistory();
  const [innerHeight, setInnerHeight] = useState(height);
  return (
    <Box overflowX="hidden">
      <Header />
      <Box bgcolor="#1A1A31" height={innerHeight - 123 + "px"}>
        <Box className={commonClasses.navContainer} height={1}>
          <Box
            display="flex"
            className={commonClasses.alignItemsStretch}
            height={1}
          >
            <Box width={0.5}>
              <Box pt={3} width={0.6}>
                <Paper
                  elevation={3}
                  style={{ borderRadius: "20px", padding: "30px" }}
                >
                  <Box display="flex" alignItems="center" height="400px">
                    <Box display="block">
                      <Box component="h1" mt={0} fontWeight="500">
                        Request Sent
                      </Box>
                      <form className={classes.form} noValidate>
                        <Box
                          component="p"
                          m={0}
                          fontSize={14}
                          fontWeight="bold"
                        >
                         We have sent you a reset link on
                        </Box>
                        <Box
                          component="p"
                          m={0}
                          fontSize={14}
                          fontWeight="bold"
                        >
                          {email}
                        </Box>
                        <Box
                          component="p"
                          m={0}
                          fontSize={14}
                          fontWeight="bold"
                        >
                          Kindly follow the steps and login with new password.
                        </Box>
                      </form>

                      <Box
                        mt={3}
                        display="flex"
                        className={commonClasses.justifyContentBetween}
                      >
                        <Box>
                          <ButtonGroup disableElevation>
                            <Button
                              className={classes.selectedClass}
                              onClick={() => {
                                history.push("/sign-in");
                              }}
                            >
                              login
                            </Button>
                          </ButtonGroup>
                        </Box>
                      </Box>
                    </Box>{" "}
                  </Box>
                </Paper>
              </Box>
            </Box>
            <Box width={0.5}>
              <Box
                display="flex"
                justifyContent="flex-end"
                height={1}
                alignItems="flex-end"
              >
                <Box
                  component="img"
                  src={
                    process.env.REACT_APP_CUSTOMER_PORTAL_URL +
                    "assets/images/arrows.png"
                  }
                  mb={16}
                  mr={5}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
